package io.peekandpoke.kraft.forms

/**
 * Represents a single form field with validation, touch tracking, and error state.
 */
interface FormField<T> {

    /**
     * The errors the field currently has
     */
    val errors: List<String>

    /**
     * Returns true when the field has errors
     */
    val hasErrors get() = errors.isNotEmpty()

    /**
     * Marker if the component was touched.
     */
    val touched: Boolean

    /**
     * Resets the form field.
     *
     * Set the input value to initial value.
     * Marks the field as not touched.
     * Clears all errors
     */
    fun reset()

    /**
     * Marks the form field as touched.
     */
    fun touch()

    /**
     * Marks the form field as not touched.
     */
    fun untouch()

    /**
     * Validates all rules and returns true if all rules are fulfilled.
     *
     * Suspends because rules may validate against async sources (see [io.peekandpoke.kraft.forms.validation.Rule]).
     */
    suspend fun validate(): Boolean
}
